import { useState } from "react";
import type { Invitation } from "../../lib/types";
import { Confirmation } from "./Confirmation";
import { GuestSearch } from "./GuestSearch";
import { RsvpForm } from "./RsvpForm";

type Stage = "search" | "form" | "confirmed";

export function RsvpSection() {
  const [stage, setStage] = useState<Stage>("search");
  const [invitation, setInvitation] = useState<Invitation | null>(null);

  return (
    <section id="rsvp" className="section rsvp">
      <div
        className="rsvp__ornament"
        data-par="0.5"
        aria-hidden="true"
        style={{ left: -260, bottom: -140, width: 340, height: 260, opacity: 0.1 }}
      />
      <div
        className="rsvp__ornament"
        data-par="0.66"
        aria-hidden="true"
        style={{ right: 20, top: 40, width: 16, height: 16 }}
      />

      <div className="container container--720 rsvp__inner">
        <div className="section-head">
          <h2 className="h2">RSVP</h2>
        </div>
        {stage === "search" && (
          <GuestSearch
            onFound={(found) => {
              setInvitation(found);
              setStage("form");
            }}
          />
        )}

        {stage === "form" && invitation && (
          <RsvpForm
            invitation={invitation}
            onSubmitted={(saved) => {
              setInvitation(saved);
              setStage("confirmed");
            }}
            onStartOver={() => {
              setInvitation(null);
              setStage("search");
            }}
          />
        )}

        {stage === "confirmed" && invitation && (
          <Confirmation invitation={invitation} onEdit={() => setStage("form")} />
        )}
      </div>
    </section>
  );
}
